import { TablePaginationContext } from '@/components';
import { PagedTable } from '@/components/PagedTable/PagedTable';
import { useGetEmployeesByOrganization } from '@/modules/Users/queries';
import { useEmployeesColumns } from '@/shared/hooks/useEmployeesColumns';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

type OrganizationEmployeesTabProps = {
  organizationId: number;
};

export const OrganizationEmployeesTab = ({
  organizationId,
}: OrganizationEmployeesTabProps) => {
  const { t } = useTranslation();
  const { page, searchTerm, tableSort } = useContext(TablePaginationContext);
  const sort = tableSort[0];
  const { data: employees, isLoading } = useGetEmployeesByOrganization({
    organizationId,
    pageNumber: page,
    filter: searchTerm,
    sortBy: sort?.columnId,
    sortOrder: sort?.direction,
  });

  const columns = useEmployeesColumns();

  return (
    <PagedTable
      title={t('employees')}
      columns={columns}
      isLoading={isLoading}
      page={employees}
      emptyStateMessage={t('no_employees_available')}
    />
  );
};
